/**
 * Shared font style for displaying numerals in PreK and K components.
 * Uses system UI fonts with tabular numbers for consistent digit widths.
 * Avoids slashed zeros that can confuse young learners.
 */
export const NUMERAL_FONT_STYLE = {
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontVariantNumeric: 'tabular-nums',
} as const;

export const typography = {
  headings: {
    h1: 'text-5xl font-bold',
    h2: 'text-3xl font-bold',
    h3: 'text-2xl font-bold',
    h4: 'text-xl font-bold',
  },
  body: {
    regular: 'text-base',
    small: 'text-sm',
    tiny: 'text-xs',
  },
  weights: {
    regular: 'font-normal',
    medium: 'font-medium',
    bold: 'font-bold',
  },
}; 